<template>
  <kst-table paginated view-mode
    :data="items"
    :failure="failureList"
    :loading="isListLoading"
    :selected.sync="userData.selected"
  >
    <b-table-column
      v-slot="{ column, row }"
      field="ClientName"
      :label="Catalog.ClientName.Label"
    >
      <kst-value ellipsis :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column
      cell-class="ks-col-alias"
      field="Alias"
      :label="Catalog.Alias.Label"
      v-slot="{ column, row }"
    >
      <kst-value ellipsis :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column
      field="Address"
      :label="ClientAddressCatalog.Address.Label"
      v-slot="{ column, row }"
    >
      <kst-value ellipsis :field="column.field" :data="row" :catalog="ClientAddressCatalog"/>
    </b-table-column>

    <b-table-column
      field="ContactMobile"
      :label="ClientAddressCatalog.ContactMobile.Label"
      v-slot="{ column, row }"
    >
      <kst-value ellipsis :field="column.field" :data="row" :catalog="ClientAddressCatalog"/>
    </b-table-column>

    <b-table-column
      field="ContactPhone"
      :label="ClientAddressCatalog.ContactPhone.Label"
      v-slot="{ column, row }"
    >
      <kst-value ellipsis :field="column.field" :data="row" :catalog="ClientAddressCatalog"/>
    </b-table-column>

    <b-table-column
      field="ContactEmail"
      :label="ClientAddressCatalog.ContactEmail.Label"
      v-slot="{ column, row }"
    >
      <kst-value ellipsis :field="column.field" :data="row" :catalog="ClientAddressCatalog"/>
    </b-table-column>
  </kst-table>
</template>

<script>
import Catalog from "../ClientCatalog.js";
import ClientAddressCatalog from "../ClientAddressCatalog.js";

export default {
  props: {
    failureList: String,
    isListLoading: Boolean,
    items: Array,
    userData: Object
  },
  data: () => ({
    Catalog: Catalog,
    ClientAddressCatalog: ClientAddressCatalog
  })
}
</script>